import styled from 'styled-components';

export const Container = styled.b`
  font-weight: ${({ theme }) => theme.weights.medium};
  color: ${({ theme }) => theme.colors.gray4};
`;
